// components/ListLeave/ListLeave.js
import React, { useState } from 'react';
import api from '../../services/api';
import { Button } from '../UI/Button.js';
import { Dropdown } from '../UI/Dropdown.js';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';
import styled from 'styled-components';
import Select from 'react-select'; // Import react-select

const cellStyle = { border: '1px solid #ccc', padding: '8px' };

const ListLeave = () => {
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [selectedSignTypes, setSelectedSignType] = useState([]);
  
  const [leaveResults, setLeaveResults] = useState([]);
  const hasNameColumn = leaveResults.some(item => item.name_surname !== null && item.name_surname !== undefined);
  
  const signTypesOptions = [
  { value: 'Vacaciones', label: 'Vacaciones' },
  { value: 'Baja medica', label: 'Baja médica' },
  { value: 'Permiso cuidado de menor', label: 'Permiso cuidado de menor' },
];
  
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // Last 10 years
  const months = Array.from({ length: 12 }, (_, i) => i + 1); // 1-12
  const isOptionSelected = (option) => {
    return selectedSignTypes.some(selected => selected.value === option.value);
  };


  const handleListLeave = async () => {
  try {
    let url = '/listleaves';
    const params = new URLSearchParams();
    if (year) params.append('year', year); 
    if (month) params.append('month', month);
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
	
	const payload = {
        leave_types: selectedSignTypes.map(option => option.value),
      };

    const response = await api.post(url, payload);
	if (response.data.length === 0) {
      alert('No se encontraron ausencias con los filtros seleccionados.');
    }
	setLeaveResults(response.data);
	//setYear(null);
	//setMonth(null);
	//setSelectedSignType(signTypesOptions)
  } catch (error) {
      console.error('Listing leave failed', error);
      alert('Listing leave failed');
	  }
  };
  
  return (
    <div>
      <h2>Lista de ausencias</h2>
	  <FormContainer>
      <FullWidth>
          <Dropdown value={year} onChange={(e) => setYear(e.target.value)} >
            <option value="">Año</option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
        <FullWidth>
          <Dropdown value={month} onChange={(e) => setMonth(e.target.value)} >
            <option value="">Mes</option>
            {months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </Dropdown>
        </FullWidth>
	   <FullWidth>
			<Select
				isMulti
				onChange={(selectedOptions) => setSelectedSignType(selectedOptions)}
				placeholder="Selecciona tipo de ausencia"
				isOptionSelected={isOptionSelected}
				closeMenuOnSelect={false}
				options={signTypesOptions}
			/>
	  </FullWidth>
	  <FullWidth>
      <Button onClick={handleListLeave}>Mostrar</Button>
	  </FullWidth>
	  </FormContainer>
	  
	  {leaveResults.length > 0 && (
  <div style={{ marginTop: '20px' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
      <thead>
		<tr>
			{hasNameColumn && <th style={cellStyle}>Nombre</th>}
			<th style={cellStyle}>Inicio</th>
			<th style={cellStyle}>Fin</th>
			<th style={cellStyle}>Tipo</th>
		</tr>
	  </thead>
	  <tbody>
	  {leaveResults.map((item, index) => (
		  <tr key={index}>
		  {hasNameColumn && (
			  <td style={cellStyle}>{item.name_surname || '—'}</td>
		  )}
		  <td style={cellStyle}>{new Date(item.start_time).toLocaleString()}</td>
		  <td style={cellStyle}>{new Date(item.end_time).toLocaleString()}</td>
		  <td style={cellStyle}>{item.type}</td>
		  </tr>
	  ))}
	 </tbody>
    </table>
  </div>
)}
	  
    </div>
  );
};

export default ListLeave;